export default __webpack_public_path__ + "static/media/loading-loop-300.c8fb6ed9.png";